import React from 'react';

interface IProps {
  alt: string;
  className?: string;
  children?: any;
  src: string;
  height?: string;
}

const BackgroundImage = ({ src, className, children, height }: IProps): JSX.Element => (
  <div className={`background-image ${className || ''}`} style={height ? { height } : {}}>
    <div className="bg-wrapper">
      <div className={'background-image-img'} style={{ backgroundImage: `url(${src})` }} />
      <div className="bg-mask2" />
      <div className="bg-mask1" />
    </div>
    <div className="content">{children}</div>
  </div>
);

export { BackgroundImage };
